import React from 'react';

// Content wrapper for the standard pages. Navigation now lives in the app
// shell's NavRail (left of the avatar); this only frames the page content
// inside the shell's content column.
function SidebarPageLayout({ children, fullBleed = false }) {
  return (
    <div className="relative h-full w-full overflow-hidden">
      <main className={`${fullBleed ? 'p-0' : 'p-4 md:p-7'} overflow-auto h-full`}>
        {fullBleed ? (
          <div className="h-full w-full">{children}</div>
        ) : (
          <div className="mx-auto w-full max-w-[1300px]">
            <div className="vica-surface vica-surface-flush p-5 md:p-7">{children}</div>
          </div>
        )}
      </main>
    </div>
  );
}

export default SidebarPageLayout;
